var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"giris"},[_c('a',{staticClass:"logo tr",attrs:{"href":"https://www.fabsis.com.tr"}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('div',{staticClass:"footer"}),_vm._v(" "),_c('div',{staticClass:"after"},[_c('a',{staticClass:"logo tr",attrs:{"href":"https://www.fabsis.com.tr"}}),_vm._v(" "),_c('el-tag',{staticStyle:{"position":"relative"}},[_c('b',[_vm._v("Paylaşım")]),_vm._v(" Otomasyonu\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d2b7eb7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Giris/_route.vue
// module id = 682
// module chunks = 0